var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { useScreenSize } from '../../hooks/useScreenSize';
import { Headline } from '../Headline';
import { BackLink } from '../BackLink';
import { Button } from '../Button';
import { Tooltip } from '../Tooltip';
export const TakeoverHeader = (_a) => {
    var { actions, backLabel, className, onBack, onClose, theme, title } = _a, props = __rest(_a, ["actions", "backLabel", "className", "onBack", "onClose", "theme", "title"]);
    const TakeoverHeaderClasses = classnames('TakeoverHeader', className, `TakeoverHeader--${theme}`);
    const screensize = useScreenSize();
    const getBackLabel = () => {
        if (!onBack)
            return;
        if (screensize.smallerThan.tablet) {
            return (React.createElement(Tooltip, { text: backLabel, portal: true, direction: "br", className: "c-inherit" },
                React.createElement(Button, { fill: "subtle", iconName: "chevron_left", size: "small", className: "TakeoverHeader__close", "aria-label": backLabel, onClick: onBack })));
        }
        return (React.createElement(BackLink, { className: "TakeoverHeader__back-link", pageLabel: backLabel, onClick: onBack }));
    };
    return (React.createElement("div", Object.assign({ className: TakeoverHeaderClasses }, props),
        React.createElement("div", { className: "TakeoverHeader__left" }, getBackLabel()),
        React.isValidElement(title) ? (title) : (React.createElement(Headline, { className: "TakeoverHeader__title" }, title)),
        React.createElement("div", { className: "TakeoverHeader__right" },
            actions && (React.createElement("div", { className: "TakeoverHeader__actions" }, actions)),
            onClose && (React.createElement(Button, { "aria-label": "close takeover", fill: "subtle", className: "TakeoverHeader__close", iconName: "clear", size: "xsmall", onClick: onClose })))));
};
TakeoverHeader.defaultProps = {
    theme: 'dark',
};
//# sourceMappingURL=TakeoverHeader.js.map